import DataTable from "react-data-table-component";
import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "../widgets/Loading";
import { GetTransactions } from "../../store/actions/transactionsActions";

class TransactionsTableComponent extends Component {
  STYLES = {
    headCells: {
      style: {
        fontSize:
          "calc( 1.07rem + (1.2 - 1.07) * ((100vw - 20rem) / (48 - 20)))",
        lineHeight:
          "calc( 1.4 * (1.07rem + (1.2 - 1.07) * ((100vw - 20rem) / (48 - 20))))",
        wordBreak: "break-word",
        wordWrap: "break-word",
      },
    },
    cells: {
      style: {
        fontSize:
          "calc( 1.07rem + (1.2 - 1.15) * ((100vw - 20rem) / (48 - 20)))",
        lineHeight:
          "calc( 1.4 * (1.07rem + (1.15 - 1.07) * ((100vw - 20rem) / (48 - 20))))",
        wordBreak: "break-word",
        wordWrap: "break-word",
        fontWeight: "400",
      },
    },
  };

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  componentDidMount() {
    if (this.props.profile.profile !== null) {
      this.props.getTransactions();
    }
  }

  componentDidUpdate(pr, cr) {
    if (!this.props.transaction.loading || pr.transaction.loading) {
      document.title = "Transactions";
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      searchInput: "",
      data: this.originalData,
      COLUMNS: [
        {
          name: "DATE",
          selector: "timestamp",
          cell: (t) => (
            <p>
              {t.timestamp !== undefined
                ? t.timestamp.toDate().toDateString()
                : ""}
            </p>
          ),
          sortable: true,
        },
        {
          name: "TYPE",
          cell: (t) => (
            <p>
              {t.specificType === 1
                ? "Deposit"
                : t.specificType === 3
                ? "AD Payment"
                : t.specificType === 5
                ? "Refund"
                : t.specificType === 6
                ? t.correctiontype === 1
                  ? "Correction (+)"
                  : "Correction (-)"
                : "-"}
            </p>
          ),
          selector: "specificType",
          sortable: true,
          filterable: true,
        },
        {
          name: "AMOUNT",
          selector: "amount",
          cell: (t) => <p>{t.amount && t.amount.toFixed(2)} ETB </p>,
          filterable: true,
          sortable: true,
        },
      ],
    };
  }

  render() {
    //let { data, searchInput } = this.state;

    return (
      <div>
        <section
          className="section-table cid-ssS3CJ4LIn transactionstable"
          id="table1-1g"
        >
          <div className="container container-table">
            <h2 className="mbr-section-title mbr-fonts-style align-center pb-3 display-2">
              Transactions
            </h2>
          </div>
          {/* {this.props.fixclaim.loading ? (
          <Loading />
        ) : ( */}
          {this.props.transaction.loading ? (
            <div className="row justify-content-center ">
              <div className="col-lg-8 form-group">
                <Loading />
              </div>
            </div>
          ) : (
            <div className="table-wrapper">
              {/* <div className="container">
      <div className="row search">
        <div className="col-md-6" />
        <div className="col-md-6">
          <div className="dataTables_filter">
            <label className="searchInfo mbr-fonts-style display-7">
              Search:
            </label>
            <input
              size="large"
              className="form-control input-sm"
              name="searchInput"
              label="Search"
            />
          </div>
        </div>
      </div>
    </div> */}

              <div className="container scroll">
                <DataTable
                  className="table isSearch"
                  columns={this.state.COLUMNS}
                  data={this.props.transaction.transactions}
                  customStyles={this.STYLES}
                  pagination={true}
                />
              </div>
            </div>
          )}
          {/* //)} */}
          {this.props.profile.systemuser && !this.props.transaction.loading && (
            <div className="container">
              <div className="row">
                <div className="сol-3 col-md-12 text-right ">
                  <a
                    href="#callus"
                    className="btn btn-black display-3 txnclaimforfix"
                  >
                    Report an Error
                  </a>
                </div>
              </div>
            </div>
          )}
        </section>
        {this.props.profile.systemuser && !this.props.transaction.loading && (
          <section className="features17 cid-ssS9AYL8y5 callus" id="callus">
            <div className="container">
              <div className="row justify-content-center mt-4">
                <div className="сol-8 col-md-8 ">
                  <p className="mbr-text ads-name-text mbr-fonts-style display-9  align-center">
                    If there is any problem you noticed with this particular
                    Advertisement, don't hesitate to call
                  </p>
                </div>
                <div className="сol-8 col-md-8 ">
                  <h5 className="item-title mbr-fonts-style display-5 align-center">
                    <a
                      href={
                        this.props.profile.systemuser &&
                        "tel:" + this.props.profile.systemuser.phone
                      }
                      className="text-primary"
                    >
                      <strong>
                        {this.props.profile.systemuser &&
                          this.props.profile.systemuser.phone}
                      </strong>
                    </a>
                  </h5>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.profile,
    firebase: state.firebase,
    transaction: state.transaction,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTransactions: () => dispatch(GetTransactions()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionsTableComponent);
